/* eslint-disable import/no-cycle */
import { FetchStatus } from '@flatsy/types/FetchStatus'
import { createSlice } from '@reduxjs/toolkit'
import { fetchBooking } from './Action'
import { BookingState } from './Type'

export const initialState: BookingState = {
  booking: null,
  getStatus: FetchStatus.IDLE,
}

// SLICE
export const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch
    builder.addCase(fetchBooking.pending, (state) => {
      state.getStatus = FetchStatus.LOADING
    })
    builder.addCase(fetchBooking.fulfilled, (state, action) => {
      state.booking = action.payload
      state.getStatus = FetchStatus.SUCCEEDED
    })
    builder.addCase(fetchBooking.rejected, (state) => {
      state.getStatus = FetchStatus.FAILED
    })
  },
})
